module.exports = __webpack_public_path__ + "img/contact_active.e8ba03d0.svg";